import PropTypes from "prop-types";
import React from "react";

import { useDeviceInfo } from "@swa-ui/browser";

import { Grid } from "../Grid";

/**
 * PageGrid will automatically provide a right-sized container for the current device's viewport with
 * the correct width and column definitions.
 */

export const PageGrid = (props) => {
  const { children, className, maxWidth = true, role, style } = props;
  const { gridColumnSpacing, gridPadding, gridNumberColumns, gridRowSpacing, mediaWidthLimits } =
    useDeviceInfo();

  return <Grid {...getProps()}>{children}</Grid>;

  function getProps() {
    return {
      className,
      gutterSpacing: gridColumnSpacing,
      horizontalPadding: gridPadding,
      numberOfColumns: gridNumberColumns,
      role,
      rowSpacing: gridRowSpacing,
      style: {
        ...(maxWidth &&
          mediaWidthLimits && { maxWidth: mediaWidthLimits.max ?? mediaWidthLimits.min }),
        ...style,
      },
    };
  }
};

PageGrid.displayName = "PageGrid";

PageGrid.propTypes = {
  /** The content that will be displayed when PageGrid is rendered. */
  children: PropTypes.node.isRequired,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Controls whether the grid has a maximum width constraint. */
  maxWidth: PropTypes.bool,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Additional CSS styling to be applied to outermost PageGrid container. */
  style: PropTypes.object,
};
